/***
 * Created on 2023/12/22
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React from 'react';
import {useTranslation} from "react-i18next";
import {
    CHINA,
    convertToQNAPLang,
    getAppCMSUrl,
    getCurrentDomainRegion,
    getPrivacyPolicyUrl,
    getQNAPUrl
} from "../service/common";
import facebook_svg from "../static/img/utils/logo-facebook-white.svg";
import x_svg from "../static/img/utils/logo-x-white.svg";
import youtube_svg from "../static/img/utils/logo-youtube-white.svg";
import china_jin_svg from "../static/img/utils/china_jin_icon.png";
import webo_svg from "../static/img/utils/logo-sina-weibo.svg";
import youku_svg from "../static/img/utils/logo-youku.svg";
import bilibili_svg from "../static/img/utils/logo-bilibili.svg";
import china_jin_icon from "../static/img/utils/china_jin_icon.png";


function Footer(props) {
    const { t, i18n } = useTranslation();
    const region = getCurrentDomainRegion();

    return (
        <>
            <div className="utils">
                <ul className="util__links">
                    <li data-link-type="qnap"><a href={`${getQNAPUrl()}/${convertToQNAPLang(i18n.language)}`} target="_blank">{t('@About us@')}</a></li>
                    <li data-link-type="qnap"><a href={`${getPrivacyPolicyUrl()}`} target="_blank">{t('@Privacy policy@')}</a></li>
                    <li data-link-type="qnap"><a href={`${getQNAPUrl()}/${convertToQNAPLang(i18n.language)}/before_buy/con_show.php?op=showone&cid=15`} target="_blank">{t('@Terms of service@')}</a></li>
                    <li data-link-type="qnap"><a href={`${window.acc_mf.common.APP_QNAP_SERVICE_URL}/${convertToQNAPLang(i18n.language)}`} target="_blank">{t('@Contact us@')}</a></li>
                    <li data-link-type="qnap"><a href={window.acc_mf.common.APP_FORUM_URL} target="_blank">{t('@Forum@')}</a></li>
                    <li data-link-type="qnap"><a href={`${getAppCMSUrl()}/security?lang=${i18n.language}`} target="_blank">{t('@Security Disclaimer@')}</a></li>
                    { region !== CHINA &&
                        <>
                            <li data-link-type="sns" data-sns-name="facebook">
                                <a href="https://www.facebook.com" target="_blank"><img src={facebook_svg} alt="facebook"/></a>
                            </li>
                            <li data-link-type="sns" data-sns-name="x">
                                <a href="https://www.twitter.com" target="_blank"><img src={x_svg} alt="X"/></a>
                            </li>
                            <li data-link-type="sns" data-sns-name="youtube">
                                <a href="https://www.youtube.com" target="_blank"><img src={youtube_svg} alt="youtube"/></a>
                            </li>
                        </>
                    }

                    {
                        region === CHINA &&
                        <>
                            <li data-link-type="sns" data-sns-name="weibo" data-location="cn"><a href="http://e.weibo.com/qnap?ref=http%3A%2F%2Fwww.qnap.com%2Fen%2Findex.php%3Flang%3Den%26sn%3D850" target="_blank" className="!w-24px"><img src={webo_svg} alt="weibo"/></a></li>
                            <li data-link-type="sns" data-sns-name="bilibili" data-location="cn"><a href="https://space.bilibili.com/351726918" target="_blank" className="!w-40px"><img src={bilibili_svg} alt="bilibili"/></a></li>
                        </>
                    }
                </ul>
            </div>
            <div className="copy-right">
                {
                    region !== CHINA &&
                    <p>{t('@Copyright 2013; QNAP Systems, Inc. All Rights Reserved.@').replace('2013-2014', new Date().getFullYear())}</p>
                }
                {
                    region === CHINA &&
                    <>
                        <p>{`威博通科技 (上海) 有限公司 ©${new Date().getFullYear()} 版权所有`}</p>
                        <p className="mt-8 hide">京 ICP 备 15009595 号 -1 | <img src={china_jin_icon} alt="china"/>京公网安备 11010802025528 号</p>

                    </>
                }
            </div>
        </>
    );
}

export default Footer;